// Textos del widget del buscador en "fr".
//
// GENERADO por scripts/f5-build/traducciones.js desde la tabla `traducciones`.
// No editar a mano: se regenera con
//     node scripts/f5-build/traducciones.js
//
// Van congelados en el bundle porque el widget no puede llamar a {tr} desde fuera de
// renfeviajes. Cambiar un rótulo exige rebuild y despliegue, no un UPDATE.
// Volcado: 2026-09-24 · 56 textos.

export const textos = {
  188: "Enfants",
  416: "Depuis",
  7236: "Station d'attache",
  7237: "Gare d'arrivée",
  7238: "Sélectionnez une station valide",
  7239: "Enfants (0-13)",
  7240: "Enfants (0-3)",
  7241: "Sans occuper une place",
  7242: "Prêt",
  7243: "Supprimer des dates",
  7244: "Rechercher",
  7245: "Passager",
  7246: "Passagers",
  7247: "Recherchez votre produit ou votre ville ici",
  7248: "Activité",
  7249: "Rechercher un hôtel",
  7259: "Sélectionnez une option valide",
  7331: "Train + Hotel / Leisure",
  7336: "Vous souhaitez ajouter un hôtel à votre voyage ?",
  7337: "Non",
  7338: "Sélectionner les passagers",
  7339: "Plus de 13 ans",
  7340: "De 0 à 13 ans",
  7341: "De 0 à 3 ans. Ils n'occupent pas de place",
  7386: "Train + Voiture de location",
  7388: "Âge du conducteur",
  20012: "Avertissement",
  20013: "Dans les forfaits avec hôtel, il n'est pas possible de sélectionner le même jour aller-retour",
  20766: "Ouais",
  20808: "Jusqu'à",
  20814: "produits",
  20815: "Destinations",
  24531: "Nombre d'adultes",
  24543: "Âge",
  24560: "Loisirs",
  24642: "Chambres",
  24643: "Chambre",
  24851: "Sélectionner",
  25940: "Chambre",
  25942: "Adultes",
  25953: "1 Chambre, 2 Adultes",
  25967: "Date de départ de l'hôtel",
  41044: "Ville",
  45897: "Sens Unique",
  45898: "Aller-retour",
  46510: "Annuler",
  46615: "Sans retour",
  46629: "choisir les horaires",
  46630: "Accepter",
  46641: "Sélectionner",
  87088: "Aller-retour",
  147090: "Hôtel",
  344623: "Un voyage sans retour",
  1479751: "Train + Hôtel + Loisirs",
  1479756: "Date d'arrivée à l'hôtel",
  1479757: "Date de départ de l'hôtel",
  2011810: "De quand à quand voulez-vous la voiture ?",
}
